<div class="access premium-access-area pb-100">
    <div class="container">
        <div class="row align-items-center" style="border: solid 1px #ccc;
        margin: 15px;
        border-radius: 1%;padding:0px">
            <div class="col-lg-8 col-md-12">
                <div class="premium-access-content">
                    <h2>Nous rejoindre ?</h2>
                    <p>Remplir le formulaire de pré-inscription en ligne et notre équipe reviendra vers toi </p>
                    <p>Sinon écrire au 06-95-34-06-78
                    </p><a rstyle="padding: 8px;
                width: 150px;" routerLink="/registration" class="title"
                        ng-reflect-router-link="/profile-authentication"
                        href="/odemy-ng/profile-authentication">Pré-inscription<span></span></a>
                </div>
            </div>
            <div class="col-lg-4 col-md-12" style="padding:0">
                <div class="get-instant-courses-image"><img src="assets/img/join.png" alt="image">
                </div>
            </div>
        </div>
    </div>
</div>